import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { MaterialReactTable } from 'material-react-table';
import { Box, Button } from '@mui/material';
import '../css/StageTrackerPage.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faEye } from '@fortawesome/free-solid-svg-icons';
import BACKEND_BASE_URL from './../config';

function StageTrackerPage() {
    const [stageLoading, setStageLoading] = useState(false);
    const [stageData, setStageData] = useState({});
    const [issueDataLoading, setIssueDataLoading] = useState(false);
    const [issueData, setIssueData] = useState([]);
    const [stageHeading, setStageHeading] = useState('');

    useEffect(() => {
        setStageLoading(true);
        const fetchStageData = async () => {
            try {
                const sprintData = localStorage.getItem('sprintData');
                const sprintDataParsed = sprintData ? JSON.parse(sprintData) : {};
                const sprint_id = typeof sprintDataParsed.sprint_id !== 'undefined' ? sprintDataParsed.sprint_id : '';
                const response = await fetch(`${BACKEND_BASE_URL}/board/stages?sprintId=${sprint_id}`, {
                    headers: { 'ngrok-skip-browser-warning': 'true' }
                });
                const data = await response.json();
                if (data.success) {
                    setStageData(data.data);
                }
            } catch (error) {
                console.error('Error fetching stage data:', error);
            } finally {
                setStageLoading(false);
            }
        };

        fetchStageData();
    }, []);

    const handleStage = async (stageKey) => {
        setIssueDataLoading(true);
        setStageHeading(stageKey);
        try {
            const sprintData = localStorage.getItem('sprintData');
            const sprintDataParsed = sprintData ? JSON.parse(sprintData) : {};
            const sprint_id = typeof sprintDataParsed.sprint_id !== 'undefined' ? sprintDataParsed.sprint_id : '';
            const response = await fetch(`${BACKEND_BASE_URL}/sprint/stageTime?stage=${stageKey}&sprintId=${sprint_id}`, {
                headers: {
                    'ngrok-skip-browser-warning': 'true',
                },
            });
            const data = await response.json();
            if (data.success) {
                setIssueData(data.data);
            }
        } catch (error) {
            console.error('Fetch error:', error);
        } finally {
            setIssueDataLoading(false);
        }
    };


    const stageColumns = [
        {
            header: 'Status Name',
            accessorKey: 'name',
            size: 300,
        },
        {
            header: 'Active Tickets',
            accessorKey: 'count',
            size: 20,
        },
        {
            header: 'View',
            accessorKey: 'view',
            enableSorting: false,
            enableColumnFilter: false,
            size: 20,
            Cell: ({ row }) => (
                <Button
                    variant="outlined"
                    size="small"
                    onClick={() => handleStage(row.original.name)}
                    title="View Stage"
                >
                    <FontAwesomeIcon icon={faEye} />
                </Button>
            ),
        },
    ];

    return (
        <div className="container py-4">
            <div className="d-flex align-items-center justify-content-between p-3 bg-white shadow-sm rounded border mb-4">
                <h4 className="mb-0 fw-bold">
                <i className="bi bi-people-fill me-2"></i>
                Status wise Time in JIRA Issues
                </h4>
            </div>

            {stageLoading ? (
                <div className="d-flex justify-content-center my-5">
                    <div className="p-4 bg-white rounded shadow-sm border text-center" style={{ minWidth: '300px' }}>
                        <FontAwesomeIcon icon={faSpinner} spin size="2x" className="text-primary mb-3" />
                        <h6 className="mb-0 text-muted">Loading Active Statuses...</h6>
                    </div>
                </div>
            ) : (
                <Box className="mb-4">
                    <Box mt={2} sx={{ maxHeight: 350, overflow: 'auto' }}>
                        <MaterialReactTable
                            columns={stageColumns}
                            data={stageData?.stages ?? []}
                            enableDensityToggle={false}
                            enableGlobalFilterToggle={false}
                            enablePagination={false}
                            initialState={{
                                showGlobalFilter: true,
                                density: 'compact',
                            }}
                        />
                    </Box>
                </Box>
            )}

            {issueDataLoading ? (
                <div className="d-flex justify-content-center my-5">
                    <div className="p-4 bg-white rounded shadow-sm border text-center" style={{ minWidth: '300px' }}>
                        <FontAwesomeIcon icon={faSpinner} spin size="2x" className="text-primary mb-3" />
                        <h6 className="mb-0 text-muted">Processing your request...</h6>
                    </div>
                </div>
            ) : issueData?.issues?.length > 0 ? (
                <>
                <div class="row">
                    <div class="col-sm-12">
                        <h5 className="mt-2 mb-2">Previously or currently in Status: <b>{stageHeading}</b></h5>
                    </div>
                </div>
                <ul className="list-group">
                    {issueData.issues.map((issue, index) => (
                        <li className="list-group-item-new">
                            <div className="row">
                                <div className="col-sm-3">
                                    <Link
                                        to={`/issue-tracker/${issue.key}`}
                                        style={{ textDecoration: 'none', color: '#007bff' }}
                                    >
                                        {issue.key}
                                    </Link>
                                </div>
                                <div className="col-sm-7">
                                    <p>{issue.summary}</p>
                                </div>
                                <div className="col-sm-2">
                                    <strong>Duration:</strong> {issue.duration}
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
                </>
            ) : (
                <p className="text-center text-muted">No issues to display. Click a status to load data.</p>
            )}
        </div>
    );
}

export default StageTrackerPage;
